export default "__VITE_ASSET__ab482da2__"